module.exports = __webpack_public_path__ + "img/adas-hil-2.6cdcdf57.svg";